import React, { useEffect, useState } from "react";
import Select from "react-select";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const MasterReport = () => {
  const dispatch = useDispatch();

  const [master, setMaster] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emptype, setEmpType] = useState([]);
  const [emp, setEmp] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [empStatus, setEmpStatus] = useState([]);
  const [getdataClicked, setGetdataClicked] = useState(false);
  const [apiStatus, SetApiStatus] = useState(undefined);

  useEffect(() => {
    dispatch(updateNavbarHeading("Project Master Report"));
  }, []);

  let filters = {
    EmpType: 0,
    Emp: "",
    Customer: 0,
    ProjType: 0,
    ProjStatus: 0,
    EmpStatus: 0,
  };
  const [filter, setFilter] = useState(filters);

  useEffect(() => {
    fetchReport();
  }, []);

  const columns = {
    Code: { text: "EMP ID", visible: true },
    EmployeeName: { text: "Employee", visible: true },
    ClientName: { text: "Customer", visible: true },
    name: { text: "Project", visible: true },
    ProjectTypes: { text: "Project Type", visible: true },
    Role: { text: "Role", visible: true },
    SkillName: { text: "Technology", visible: true },
    LocationName: { text: "Location", visible: true },
    FromDate: { text: "Start Date", align: "center", visible: true },
    ToDate: { text: "Org. End Date", align: "center", visible: true },
    ExtendedTo: { text: "Ext. End Date", align: "center", visible: true },
    ActualEndDate: { text: "Act. End Date", align: "center", visible: true },
    InvoiceRate: { text: "Billing Rate", align: "end", visible: true },
    Frequency: { text: "Frequency", visible: true },
    AccountManager: { text: "Acc. Manager", visible: false },
    ROMPoC: { text: "ROM PoC", visible: false },
    CP_Name: { text: "CP Name", visible: false },
    DP_Name: { text: "DP Name", visible: false },
    PM_Name: { text: "PM Name", visible: false }
  };
  const fetchReport = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rom-report/1?P_EmpType=&P_EmployeeID=&P_ClientID=&P_ProjectType=&P_ProjectStatus=&P_EmpStatus=`
      );
      if (response?.status === 200) {
        SetApiStatus(response?.status);
        setMaster(response?.data?.header);

        // employee type dropdown
        const emptype = Object.entries(response.data.employeeType).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        emptype.unshift({ value: 0, label: "Select..." });
        setEmpType(emptype);

        // employee list dropdown
        const empp = response.data.employee.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        empp.unshift(
          { value: 0, label: "Select..." },
          { value: "", label: "All" }
        );
        setEmp(empp);

        //customer dropdown
        const cust = response.data.clients.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        cust.unshift({ value: 0, label: "Select..." });
        setCustomer(cust);

        // project type dropdown
        const prjtype = response.data.projectType.map((item) => ({
          value: item.value,
          label: item.text,
        }));

        prjtype.unshift({ value: 0, label: "Select..." });

        // Sort by value (ascending order)
        prjtype.sort((a, b) => a.value - b.value);

        // Or sort by label alphabetically
        prjtype.sort((a, b) => a.label.localeCompare(b.label));

        setProjectType(prjtype);

        // project status dropdown
        const prjstatus = Object.entries(response.data.projectStatus).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        prjstatus.unshift({ value: 1, label: "Select..." });
        setProjectStatus(prjstatus);

        // employee status
        const empstatus = Object.entries(response.data.empStatus).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        empstatus.unshift({ value: 1, label: "Select..." });
        setEmpStatus(empstatus);
      }
    } catch (error) {
      console.error("Fetching Data Error", error);
    }
  };

  const formDatas = [
    {
      name: "Employee Type",
      type: "Select",
      options: [...emptype],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...emp],
    },
    {
      name: "Customer",
      type: "Select",
      options: [...customer],
    },
    {
      name: "Project Type",
      type: "Select",
      options: [...projectType],
    },
    {
      name: "Project Status",
      type: "Select",
      options: [...projectStatus],
    },
    {
      name: "Emp Status",
      type: "Select",
      options: [...empStatus],
    },
  ];

  const handleGetData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rom-report/1?P_EmpType=${filterFormData.find((o) => o.label === "Employee Type")
          ? filterFormData.find((o) => o.label === "Employee Type").value
          : 0
        }&P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }&P_ClientID=${filterFormData.find((o) => o.label === "Customer")
          ? filterFormData.find((o) => o.label === "Customer").value
          : 0
        }&P_ProjectType=${filterFormData.find((o) => o.label === "Project Type")
          ? filterFormData.find((o) => o.label === "Project Type").value
          : 0
        }&P_ProjectStatus=${filterFormData.find((o) => o.label === "Project Status")
          ? filterFormData.find((o) => o.label === "Project Status").value
          : 0
        }&P_EmpStatus=${filterFormData.find((o) => o.label === "Emp Status")
          ? filterFormData.find((o) => o.label === "Emp Status").value
          : 0
        }`
      );

      SetApiStatus(response?.status);
      if (response.status === 200) {

        const cleanedData = response?.data?.header;
        setMaster(cleanedData);
        // setLoading(false);
      } else {
        console.error(
          "Failed to fetch Customer Report Tracker. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Customer Report Tracker:", error);
    }
  };
  const [filterFormData, setFilterData] = useState([]);
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };


  const handleReset = () => {
    setFilterData([])
    fetchReport()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={master}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              handleReset={handleReset}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              showIcon2={false}
              showIcon3={false}
              isSorting={true}
              showIcon4={true}
              showIcon5={false}
              formDatas={formDatas}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              isActionRequired={false}
              isFilterRequired={true}
              isCheckBoxRequired={false}
              // handleIcon1={handleEdit}
              // handleIcon4={handleOpen}
              handleChange={handleChange}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-person-plus icons"></i>,
                Icon4Text: "Create Employee",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterReport;
